var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-6 container-background", attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        {
          ref: "form",
          model: {
            value: _vm.formValid,
            callback: function ($$v) {
              _vm.formValid = $$v
            },
            expression: "formValid",
          },
        },
        [
          _c("v-card", { staticClass: "main-card pa-6 mb-6" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-center justify-space-between flex-wrap",
              },
              [
                _c("div", [
                  _c(
                    "h1",
                    { staticClass: "main-title" },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { color: "rgb(204 33 40)" },
                        },
                        [_vm._v(" mdi-email-edit-outline ")]
                      ),
                      _vm._v(" Configuración del correo "),
                    ],
                    1
                  ),
                  _c("p", { staticClass: "main-subtitle" }, [
                    _vm._v(
                      " Personaliza el contenido del correo que recibirán tus clientes. "
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "7" } },
                [
                  _c("v-card", { staticClass: "section-card pa-6 mb-6" }, [
                    _c("div", { staticClass: "section-header" }, [
                      _c(
                        "div",
                        { staticClass: "section-icon" },
                        [
                          _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v("mdi-domain"),
                          ]),
                        ],
                        1
                      ),
                      _c("div", [
                        _c("h2", { staticClass: "section-title" }, [
                          _vm._v("Información general"),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "mt-6" },
                      [
                        _c("label", { staticClass: "custom-label" }, [
                          _vm._v(" Nombre de la compañía "),
                        ]),
                        _c("v-text-field", {
                          staticClass: "custom-input",
                          attrs: {
                            outlined: "",
                            dense: "",
                            placeholder: "Ej: HioPOS Reports",
                            rules: [_vm.rules.required],
                          },
                          model: {
                            value: _vm.nameCompany,
                            callback: function ($$v) {
                              _vm.nameCompany = $$v
                            },
                            expression: "nameCompany",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("v-card", { staticClass: "section-card pa-6 mb-6" }, [
                    _c("div", { staticClass: "section-header" }, [
                      _c(
                        "div",
                        { staticClass: "section-icon" },
                        [
                          _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v("mdi-email-outline"),
                          ]),
                        ],
                        1
                      ),
                      _c("div", [
                        _c("h2", { staticClass: "section-title" }, [
                          _vm._v("Contenido del correo"),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "mt-6" },
                      [
                        _c("label", { staticClass: "custom-label" }, [
                          _vm._v(" Cuerpo del mensaje "),
                        ]),
                        _c("v-textarea", {
                          staticClass: "custom-input",
                          attrs: {
                            outlined: "",
                            "auto-grow": "",
                            rows: "6",
                            counter: "3000",
                            maxlength: "3000",
                            placeholder:
                              "Escribe aquí el contenido del correo...",
                            rules: [_vm.rules.required],
                          },
                          model: {
                            value: _vm.messageContent,
                            callback: function ($$v) {
                              _vm.messageContent = $$v
                            },
                            expression: "messageContent",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "mt-4" },
                      [
                        _c("label", { staticClass: "custom-label" }, [
                          _vm._v(" Texto resaltado para política de datos "),
                        ]),
                        _c("v-text-field", {
                          staticClass: "custom-input",
                          attrs: {
                            outlined: "",
                            dense: "",
                            placeholder: "Ej: clic aquí",
                            rules: [_vm.rules.required],
                          },
                          model: {
                            value: _vm.highlightText,
                            callback: function ($$v) {
                              _vm.highlightText = $$v
                            },
                            expression: "highlightText",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("v-card", { staticClass: "section-card pa-6 mb-6" }, [
                    _c("div", { staticClass: "section-header" }, [
                      _c(
                        "div",
                        { staticClass: "section-icon" },
                        [
                          _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v("mdi-shield-check-outline"),
                          ]),
                        ],
                        1
                      ),
                      _c("div", [
                        _c("h2", { staticClass: "section-title" }, [
                          _vm._v(" Política de tratamiento de datos "),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "mt-6" },
                      [
                        _c("label", { staticClass: "custom-label" }, [
                          _vm._v(" URL de política de datos "),
                        ]),
                        _c("v-text-field", {
                          staticClass: "custom-input",
                          attrs: {
                            outlined: "",
                            dense: "",
                            placeholder: "https://",
                            rules: [_vm.rules.required, _vm.rules.url],
                          },
                          model: {
                            value: _vm.policyUrl,
                            callback: function ($$v) {
                              _vm.policyUrl = $$v
                            },
                            expression: "policyUrl",
                          },
                        }),
                        _c("small", { staticClass: "helper-text" }, [
                          _vm._v(
                            " Este enlace será asignado automáticamente al texto resaltado. "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _c("v-card", { staticClass: "section-card pa-6 mb-6" }, [
                    _c("div", { staticClass: "section-header" }, [
                      _c(
                        "div",
                        { staticClass: "section-icon" },
                        [
                          _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v("mdi-phone-outline"),
                          ]),
                        ],
                        1
                      ),
                      _c("div", [
                        _c("h2", { staticClass: "section-title" }, [
                          _vm._v("Canales de contacto"),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "mt-6" },
                      [
                        _c("label", { staticClass: "custom-label" }, [
                          _vm._v(" Correo o canal de contacto "),
                        ]),
                        _c("v-text-field", {
                          staticClass: "custom-input",
                          attrs: {
                            outlined: "",
                            dense: "",
                            placeholder: "correo@empresa.com",
                            rules: [_vm.rules.required],
                          },
                          model: {
                            value: _vm.contact,
                            callback: function ($$v) {
                              _vm.contact = $$v
                            },
                            expression: "contact",
                          },
                        }),
                        _c("small", { staticClass: "helper-text" }, [
                          _vm._v(
                            " Ingrese los canales de contacto separados por comas (,). Ejemplo: correo@empresa.com, Bogotá: 6017775555, Cartagena: 6052224444 "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm.showAlert
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mb-4",
                          attrs: {
                            type: _vm.alertType,
                            border: "left",
                            "colored-border": "",
                            elevation: "2",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-end" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "white--text px-10 font-weight-bold",
                          attrs: {
                            color: "rgb(204 33 40)",
                            "x-large": "",
                            elevation: "2",
                            rounded: "",
                          },
                          on: { click: _vm.formUserByCompanySave },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v(" mdi-content-save-outline "),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.isEditing
                                  ? "Actualizar configuración"
                                  : "Guardar configuración"
                              ) +
                              " "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "5" } },
                [
                  _c("v-card", { staticClass: "preview-card pa-5" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center mb-4" },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-2",
                            attrs: { color: "rgb(204 33 40)" },
                          },
                          [_vm._v(" mdi-eye-outline ")]
                        ),
                        _c("h3", { staticClass: "preview-title" }, [
                          _vm._v(" Vista previa "),
                        ]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "preview-email" }, [
                      _c("div", { staticClass: "preview-company" }, [
                        _vm._v(' Sr(a)."Nombre Cliente" '),
                      ]),
                      _c("div", { staticClass: "preview-body" }, [
                        _vm._v(
                          " Le informamos que usted ha autorizado el tratamiento de sus datos personales, así como el uso con fines comerciales, en el establecimiento " +
                            _vm._s(
                              _vm.nameCompany || "'Nombre de la compañía'"
                            ) +
                            " en la fecha " +
                            _vm._s(new Date().toLocaleDateString("es-CO")) +
                            " a las " +
                            _vm._s(new Date().toLocaleTimeString("es-CO")) +
                            ". "
                        ),
                      ]),
                      _c("div", { staticClass: "preview-body mt-4" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.messageContent ||
                                "Aquí aparecerá el contenido del correo..."
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "preview-contact mt-6" }, [
                        _vm._v(
                          " Este correo electrónico ha sido generado automáticamente. Por favor, no responda a esta dirección de email. "
                        ),
                      ]),
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", { staticClass: "preview-body mt-6" }, [
                          _c("strong", [_vm._v("Canal de contacto:")]),
                          _vm.formattedContacts.length
                            ? _c(
                                "div",
                                { staticClass: "mt-2" },
                                _vm._l(
                                  _vm.formattedContacts,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "contact-line",
                                      },
                                      [_vm._v(" " + _vm._s(item) + " ")]
                                    )
                                  }
                                ),
                                0
                              )
                            : _c("div", { staticClass: "mt-2" }, [
                                _vm._v(" correo@empresa.com "),
                              ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "preview-body mt-6 ml-auto d-block" },
                          [
                            _c(
                              "div",
                              { staticClass: "preview-company text-center" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.nameCompany || "Nombre de la compañía"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "text-center" }, [
                              _c("img", {
                                staticClass: "logo-image",
                                attrs: { src: _vm.imageLogo, alt: "Logo" },
                              }),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.6", "z-index": "9999" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64", color: "rgb(204 33 40)" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }